// YunEmTracking.js

import { memo } from 'react'
import './YunEmTracking.css';

import YunIcon from '../YunIcon/YunIcon';

import Slider from '@material-ui/core/Slider';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputBox from '../InputBox/InputBox';

import { formatShowValue } from '../YunEmFineTune/tool';

const YunEmTracking = memo(function YunEmTracking({ emTrackingVal, handleEmTracking, emTracking, trackingPreset}){
    // 跟踪推杆右边对应插件1值 左边对应插件100值
    const sliderValue = 101 - emTrackingVal
    const labelValue = formatShowValue(emTrackingVal, trackingPreset)

    const hanleChangeTrackingVal = (val) => {
        val = 101 - val;
        handleEmTracking(val);
    }

    if (!emTracking) {
        return null
    }
    const MenuItemEle = []
    trackingPreset.forEach((ele, index) => {
        MenuItemEle.push(<MenuItem className="SelectItem" value={ele.value} key={'tracking-item-' + index}>{ele.name}</MenuItem>)
    })
    return (
        <div className="YunCommonLayoutWrapper">
            <div className="YunEmTracking YunCommonLayout">
                <div className="Label CursorDefault">
                    跟踪：
                </div>
                <Slider
                    value={sliderValue}
                    onChange={(e, val) => hanleChangeTrackingVal(val)}
                    min={1}
                    max={100} />
                <div className="RateSelect">
                    <div className="RateSelectLabel HoverColor MainColor">{labelValue}</div>
                    <YunIcon iconClass="MainColor HoverColor" icon="expand"></YunIcon>
                    <Select value="" onChange={(e, child) => handleEmTracking(child.props.value)}>
                        {MenuItemEle}
                        <InputBox val={emTrackingVal} min={1} max={100} step={1} onChange={handleEmTracking} >
                        </InputBox>
                    </Select>
                </div>
            </div>
        </div>
    )
})

export default YunEmTracking;
